import { FETCH_SUBSCRIBE_TO_PETS, FETCH_SUBSCRIBE_NOTIFICATIONS,FETCH_SUBSCRIBE_TO_PETS_BY_MRID, DELETE_SUBSCRIBER, SEND_PROMOCODE_TO_SUBSCRIBERS, FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO, FETCH_SUBSCRIBER_REPLIES,FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID,
         UPDATE_SUBSCRIBED_TO_PET } from '../actions';
const initialState = {
  subscribeToPet: [],
  subscribeNotifications: [],
  subscribeToPetByMr: [],
  deletedSubscriber: {},
  sendPromocodeToSubscribers: {},
  promoSubscribers: [],
  subscriberReplies : [],
  updatedSubscribedToPetRecord : '',
};

function subscribeToPetReducer(state = initialState, action) {
  let subscribeToPet, subscribeNotifications, subscribeToPetByMr, deletedSubscriber, sendPromocodeToSubscribers, promoSubscribers, subscriberReplies, leadSubscribedCustomers, updatedSubscribedToPetRecord;
  switch (action.type) {
    case `${FETCH_SUBSCRIBE_TO_PETS}_PENDING`:
      return { ...state, 
        loading: true,
      };
    case `${FETCH_SUBSCRIBE_NOTIFICATIONS}_PENDING`:
      return { ...state, 
        loading: true,
      };  
    case `${FETCH_SUBSCRIBE_TO_PETS_BY_MRID}_PENDING`:
      return { ...state, 
        loading: true,
      };  
    case `${DELETE_SUBSCRIBER}_PENDING`:
      return { ...state, 
        loading: true,
      }; 
    case `${SEND_PROMOCODE_TO_SUBSCRIBERS}_PENDING`:
      return { ...state, 
        loading: true,
      }; 
    case `${FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO}_PENDING`:
      return { ...state, 
        loading: true,
      }; 
    case `${FETCH_SUBSCRIBER_REPLIES}_PENDING`:
      return { ...state, 
        loading: true,
      };       
    case `${UPDATE_SUBSCRIBED_TO_PET}_PENDING`:
      return { ...state, 
        loading: true,
      };  
      
    case `${FETCH_SUBSCRIBE_TO_PETS}_FULFILLED`:
      subscribeToPet = action.payload.data;
      return { ...state, loading: false, subscribeToPet };
    case `${FETCH_SUBSCRIBE_NOTIFICATIONS}_FULFILLED`:
      subscribeNotifications = action.payload.data;
      return { ...state, loading: false, subscribeNotifications };  
    case `${FETCH_SUBSCRIBE_TO_PETS_BY_MRID}_FULFILLED`:
      subscribeToPetByMr = action.payload.data;
      return { ...state, loading: false, subscribeToPetByMr }; 
    case `${DELETE_SUBSCRIBER}_FULFILLED`:
      deletedSubscriber = action.payload.data;
      return { ...state, loading: false, deletedSubscriber };  
    case `${SEND_PROMOCODE_TO_SUBSCRIBERS}_FULFILLED`:
      sendPromocodeToSubscribers = action.payload.data;
      return { ...state, loading: false, sendPromocodeToSubscribers };  
    case `${FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO}_FULFILLED`:
      promoSubscribers = action.payload.data;
      return { ...state, loading: false, promoSubscribers };  
    case `${FETCH_SUBSCRIBER_REPLIES}_FULFILLED`:
      subscriberReplies = action.payload.data;
      return { ...state, loading: false, subscriberReplies }; 
    case `${FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID}_FULFILLED`:
        leadSubscribedCustomers = action.payload.data;
        return { ...state, loading: false, leadSubscribedCustomers }; 
    case `${UPDATE_SUBSCRIBED_TO_PET}_FULFILLED`:
        updatedSubscribedToPetRecord = action.payload.data;
        return { ...state, loading: false, updatedSubscribedToPetRecord };
        

    case `${FETCH_SUBSCRIBE_TO_PETS}_REJECTED`:
      return {...state, loading: false, subscribeToPetError: action.payload.response.data, state: initialState };
    case `${FETCH_SUBSCRIBE_NOTIFICATIONS}_REJECTED`:
      return {...state, loading: false, subscribeNotificationError: action.payload.response.data, state: initialState };
    case `${FETCH_SUBSCRIBE_TO_PETS_BY_MRID}_REJECTED`:
      return {...state, loading: false, subscribeToPetByMrError: action.payload.response.data, state: initialState };  
    case `${DELETE_SUBSCRIBER}_REJECTED`:
      return {...state, loading: false, deletedSubscriberError: action.payload.response.data, state: initialState };
    case `${SEND_PROMOCODE_TO_SUBSCRIBERS}_REJECTED`:
      return {...state, loading: false, sendPromocodeToSubscribersError: action.payload.response.data, state: initialState }; 
    case `${FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO}_REJECTED`:
      return {...state, loading: false, promoSubscribersError: action.payload.response.data, state: initialState }; 
    case `${FETCH_SUBSCRIBER_REPLIES}_REJECTED`:
      return {...state, loading: false, subscriberRepliesError: action.payload.response.data, state: initialState };   
    case `${FETCH_SUBSCRIBER_REPLIES}_REJECTED`:
      return {...state, loading: false, subscriberRepliesError: action.payload.response.data, state: initialState };  
    case `${FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID}_REJECTED`:
        return {...state, loading: false, leadSubscribedCustomersError: action.payload.response.data, state: initialState };  
    case `${UPDATE_SUBSCRIBED_TO_PET}_REJECTED`:
        return {...state, loading: false, updatedSubscribedToPetRecordError: action.payload.response.data, state: initialState };  

    default:
      return state;
  }
}

export default subscribeToPetReducer;
